import { render, staticRenderFns } from "./WorkflowStatusTable.vue?vue&type=template&id=5d67a286&scoped=true"
import script from "./WorkflowStatusTable.vue?vue&type=script&lang=js"
export * from "./WorkflowStatusTable.vue?vue&type=script&lang=js"
import style0 from "./WorkflowStatusTable.vue?vue&type=style&index=0&id=5d67a286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d67a286",
  null
  
)

export default component.exports